import { render } from "./ShopList.vue?vue&type=template&id=8acf4fca&scoped=true"
import script from "./ShopList.vue?vue&type=script&lang=js"
export * from "./ShopList.vue?vue&type=script&lang=js"

import "./ShopList.vue?vue&type=style&index=0&id=8acf4fca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8acf4fca"]])

export default __exports__